
















import Vue from 'vue'
import { State, Action } from 'vuex-class'
import Carrier from '@/modules/shipping/model/Carrier'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class CarrierSelector extends Vue {

    @Prop()
    public value: Carrier

    /**
     * Transportistas registrados
     */
    @State(state => state.shipping.carriers)
    public carriers: Carrier[]

    @Action('shipping/loadCarriers')
    public loadCarriers: () => Carrier[]

    public loading = true

    public async created () {
        await this.loadCarriers()
        this.loading = false
    }
}
